export const extractDataFromStateBasedOnStorePath = (state, storePath) => {
    const path = storePath.split(".").map((key) => key.trim());
    let storeData = state;

    for (let i = 0; i < path.length; i++) {
        const key = path[i];

        if (!storeData[key]) {
            storeData = null;
            break;
        }

        storeData = storeData[key];
    }

    return storeData;
};
